const IS_LOADING = "campaigns/showFailures/IS_LOADING";
const FAILURE_DATA = "campaigns/showFailures/FAILURE_DATA";
const IS_ERROR = "campaigns/showFailures/IS_ERROR";

export { IS_LOADING, FAILURE_DATA, IS_ERROR };
